export default __webpack_public_path__ + "static/media/header.57944d21.png";